import React from 'react'

import { IconProps } from '../Types'

export const CallOutline = ({
  title,
  fill = 'currentColor',
  stroke = 'none',
  ref,
  ...props
}: IconProps = {}) => (
  <svg
    ref={ref}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    data-title="CallOutline"
    {...{ ...(title && { 'data-title': title }), fill, stroke, ...props }}
    dangerouslySetInnerHTML={{
      __html:
        (title === undefined ? '' : `<title>${title}</title>`) +
        '<path fill-rule="evenodd" d="m16.24,2c-1.95,0-3.53,1.57-3.53,3.51v4.87c0,.38.22.73.56.9.34.17.75.13,1.06-.1l1.32-1h2.83c1.94,0,3.52-1.56,3.52-3.49,0-.41,0-.84,0-1.25,0-1.92-1.55-3.44-3.46-3.44h-2.3Zm-1.51,3.51c0-.83.68-1.51,1.51-1.51h2.3c.81,0,1.45.64,1.45,1.43,0,.41,0,.84,0,1.24,0,.82-.68,1.49-1.51,1.49h-3.16c-.21,0-.41.07-.59.19v-2.85Zm-9.32-.28c-.58,0-1.14.23-1.55.64,0,0-.01.01-.02.02l-.49.5c-.74.75-1.21,1.73-1.32,2.77-.11,1.05.13,2.11.7,3,0,0,0,.01.01.02,2.38,3.57,5.42,6.64,8.94,9.05h.02c.88.59,1.94.84,2.99.73,1.05-.12,2.02-.59,2.75-1.35l.5-.49s.01-.01.02-.02c.4-.42.62-.97.62-1.55s-.22-1.13-.62-1.55h-.01s-2.13-2.16-2.13-2.16h0c-.41-.41-.97-.65-1.55-.65s-1.14.23-1.55.64c-.04.04-.09.06-.13.06s-.09-.02-.13-.05l-3.35-3.4h0s-.03-.04-.04-.07c-.01-.03-.02-.05-.02-.08s0-.06.02-.08c.01-.03.03-.05.04-.07h.01c.4-.43.62-.98.62-1.56s-.22-1.13-.62-1.55l-2.13-2.16h0c-.41-.42-.97-.65-1.55-.65Zm-.61,2.56l.48-.5s.08-.05.13-.05.09.02.13.05l2.11,2.15s.06.09.06.15-.02.11-.06.15c-.2.2-.36.45-.47.71-.11.27-.17.56-.17.85s.06.58.17.85c.11.27.27.51.48.72l3.35,3.4h0c.41.42.97.65,1.55.65s1.14-.23,1.55-.64h0s.08-.06.12-.06.09.02.12.05h0s2.12,2.13,2.12,2.13c.04.04.06.1.06.16s-.02.12-.06.16l-.49.49h-.01c-.41.44-.96.7-1.53.77-.58.06-1.16-.07-1.65-.39-3.3-2.26-6.15-5.15-8.38-8.5-.32-.5-.46-1.11-.39-1.71.07-.6.33-1.16.75-1.58h.01Z"/>',
    }}
  />
)

CallOutline.displayName = 'CallOutline'

export const tags = ['CallOutline', '']
